import React, { useState } from "react";
import axios from "axios";
import { getToken } from "../../Utils/Common";
import * as qs from "query-string";
// import { Loader } from "../../components/loader";
// import Layout from "../../components/layout/user";

function ChangePassword() {
  const [errors, setErrors] = useState([]);
  const [errorMessage, setErrorMessage] = useState(null);
  const [successMessage, setSuccessMessage] = useState(null);
  const [panel, setPanel] = useState("");
  const token = getToken();

  const [state, setState] = React.useState({
    old_password: "",
    new_password: "",
    repeat_password: "",
  });

  const handleChange = (event) => {
    const value = event.target.value;
    setState({
      ...state,
      [event.target.name]: value,
    });
    // console.log(value);
  };

  // handle button click of login form
  const handleChangePassword = (event) => {
    event.preventDefault();

    setErrorMessage(null);
    setSuccessMessage(null);
    setErrors([]);

    // var formData = new FormData();
    // formData.append("old_password", state.old_password);
    // formData.append("new_password", state.new_password);

    // setPanel("loading");

    axios({
      method: "put",
      url: process.env.REACT_APP_API_URL + "v1/user/reset-password",
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${token}`,
      },
      data: {
        old_password: state.old_password,
        new_password: state.new_password,
      },
    })
      .then((response) => {
        // setPanel("");
        console.log(response);
        if (response.status === 200) {
          // console.log(response);
          setSuccessMessage(response.data.message);
        }
      })
      .catch((error) => {
        // setPanel("");
        console.log(error.response);
        if (error.response.status === 422) {
          setErrorMessage(error.response.data.message);
          setErrors(error.response.data.errors);
        } else if (error.response.status === 401) {
          setErrorMessage(error.response.data.message);
        } else if (error.response.status === 500) {
          setErrorMessage("Something went wrong. Please try again later.");
        } else {
          setErrorMessage("Something went wrong. Please try again later.");
        }
      });
  };
  console.log(errors);
  return (
    <>
      {/* <form> */}
      {/* <Layout /> */}
      {/* <Layout> */}
      {/* {panel === "loading" && <Loader />} */}
      <div className="d-flex flex-column flex-root mt-18">
        <div
          className="d-flex flex-column flex-column-fluid bgi-position-y-bottom position-x-center bgi-no-repeat bgi-size-contain bgi-attachment-fixed"
        >
          <div className="d-flex flex-center flex-column flex-column-fluid p-10 pb-lg-20">
            <div className="w-lg-500px mt-15 bg-body rounded border-black p-10 p-lg-15 mx-auto">
              <form
                className="form w-100"
                noValidate="novalidate"
                method="POST"
                onSubmit={handleChangePassword}
              >
                <div className="text-center mb-10">
                  <h1 className="text-dark mb-3">Change Password</h1>
                </div>
                <p style={{ color: "red" }}>
                  {errorMessage ? errorMessage : ""}
                </p>
                <p style={{ color: "green" }}>
                  {successMessage ? successMessage : ""}
                </p>

                <div className="fv-row mb-10">
                  <label className="form-label fs-6 fw-bolder text-dark">
                    Old Password
                  </label>
                  <input
                    className="form-control form-control-lg form-control-solid"
                    type="password"
                    name="old_password"
                    id="old_password"
                    placeholder="Old Password"
                    onChange={handleChange}
                    required
                  />
                  <p style={{ color: "red" }}>
                    {errors.old_password !== undefined && errors.old_password[0]
                      ? errors.old_password[0]
                      : ""}
                  </p>
                </div>

                <div className="fv-row mb-10">
                  <div className="d-flex flex-stack mb-2">
                    <label className="form-label fw-bolder text-dark fs-6 mb-0">
                      New Password
                    </label>
                  </div>

                  <input
                    className="form-control form-control-lg form-control-solid"
                    type="password"
                    name="new_password"
                    id="new_password"
                    placeholder="New Password"
                    onChange={handleChange}
                  />
                  <p style={{ color: "red" }}>
                    {errors.new_password !== undefined && errors.new_password[0]
                      ? errors.new_password[0]
                      : ""}
                  </p>
                </div>

                <div className="fv-row mb-10">
                  <div className="d-flex flex-stack mb-2">
                    <label className="form-label fw-bolder text-dark fs-6 mb-0">
                      Repeat Password
                    </label>
                  </div>

                  <input
                    className="form-control form-control-lg form-control-solid"
                    type="password"
                    name="repeat_password"
                    id="repeat_password"
                    placeholder="Repeat Password"
                    onChange={handleChange}
                  />
                  <p style={{ color: "red" }}>
                    {errors.repeat_password !== undefined &&
                      errors.repeat_password[0]
                      ? errors.repeat_password[0]
                      : ""}
                  </p>
                </div>

                <div className="text-center">
                  <button
                    type="submit"
                    className="btn btn-lg btn-dark w-100 mb-5"
                  >
                    <span className="indicator-label">Update</span>
                  </button>
                </div>
              </form>
            </div>
          </div>

          {/* <div className="d-flex flex-center flex-column-auto p-10">
            <div className="d-flex align-items-center fw-bold fs-6">
              <a href="/#" className="text-muted text-hover-primary px-2">
                About
              </a>
              <a href="/#" className="text-muted text-hover-primary px-2">
                Contact
              </a>
              <a href="/#" className="text-muted text-hover-primary px-2">
                Contact Us
              </a>
            </div>
          </div> */}
        </div>
      </div>
      {/* </Layout> */}
    </>
  );
}

export default ChangePassword;
